import '../../../../styles/workspace_styles/TenantAdministratorStyles/Dashboards/DeleteDashboardState.css';
const DeleteDashboardState = ({selectedDeleteDashboardState,setSelectedDeleteDashboardState,setDashboardStates}) =>{
    if(!selectedDeleteDashboardState) return null;
    return(
        <div className="delete-dashboard-state-parent-container">
            <div className="delete-dashboard-state-container">
                <h4>Delete dashboard state</h4>
                <p>Are you sure you want to delete dashboard state with name '{selectedDeleteDashboardState?.name}'?</p>
                <div className="delete-dashboard-state-buttons-container">
                    <button onClick={() => setSelectedDeleteDashboardState(null)}>
                        No
                    </button>
                    <button onClick={() =>{
                        setDashboardStates(prev => prev.filter(state => state.id !== selectedDeleteDashboardState.id));
                        setSelectedDeleteDashboardState(null);
                    }}>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
};
export default DeleteDashboardState;